import { formValueSelector } from 'redux-form';
import { isPrimaryFlow } from '../../../common/utils/primaryFlow';
export const BAGGAGE_VALUES = {
  FALSE: 'false',
  TRUE: 'true',
  COMBINED: 'combined'
};
export const getFormData = (form, state, name) => formValueSelector(form)(state, name);
export const getSelection = (form, state, name) => {
  return Object.values(getFormData(form, state, name) || {});
};
export const getSelected = (name, form) => state => {
  const selection = getSelection(form, state, name) || [];
  if (isPrimaryFlow()) {
    var _selection$filter;
    const allowedBaggageValues = [BAGGAGE_VALUES.TRUE, BAGGAGE_VALUES.COMBINED];
    return selection === null || selection === void 0 || (_selection$filter = selection.filter(item => {
      if (typeof item !== 'object' || item === null) {
        return null;
      }
      return allowedBaggageValues.some(val => item === null || item === void 0 ? void 0 : item.value.includes(val));
    })) === null || _selection$filter === void 0 ? void 0 : _selection$filter.filter(item => typeof item === 'object' && item !== null);
  }
  return selection;
};
export const getSelectedPostbooking = formData => {
  var _value$filter;
  const value = formData ? formData.value : null;
  return (_value$filter = value === null || value === void 0 ? void 0 : value.filter(_ref => {
    let {
      exclude
    } = _ref;
    return !exclude;
  })) !== null && _value$filter !== void 0 ? _value$filter : [];
};
export const getNumberOfUnits = (name, form) => state => {
  var _getSelected, _getSelectedPostbooki;
  const formData = getFormData(form, state, name) || {};
  return isPrimaryFlow() ? (_getSelected = getSelected(name, form)(state)) === null || _getSelected === void 0 ? void 0 : _getSelected.length : (_getSelectedPostbooki = getSelectedPostbooking(formData)) === null || _getSelectedPostbooki === void 0 ? void 0 : _getSelectedPostbooki.length;
};
export const getSelectedForTraveler = function (name, form, shouldPrefixFieldWithName) {
  if (shouldPrefixFieldWithName === void 0) {
    shouldPrefixFieldWithName = false;
  }
  return (state, id) => {
    if (!id) {
      return null;
    }
    const prefix = shouldPrefixFieldWithName ? `${name}-` : '';
    const field = `${prefix}traveler-${id}`;
    const formData = getFormData(form, state, name);
    const selectionExists = formData && formData[field];
    return selectionExists ? selectionExists.value : null;
  };
};
export const getSameAsFirstTravelerForCurrentTraveler = (name, form) => (state, id) => {
  const field = `${name}-traveler-${id}`;
  const formData = getFormData(form, state, name);
  const selectionExists = formData && formData[field] && typeof formData[field].hasSameValueAsFirstTraveler === 'boolean';
  return selectionExists ? formData[field].hasSameValueAsFirstTraveler : null;
};
export const baggagePricePerTraveler = order => {
  var _order$sellSpecificat, _order$sellSpecificat2, _order$travelers;
  const baggageSpecification = (_order$sellSpecificat = order === null || order === void 0 || (_order$sellSpecificat2 = order.sellSpecification) === null || _order$sellSpecificat2 === void 0 ? void 0 : _order$sellSpecificat2.sellPriceBaggage) !== null && _order$sellSpecificat !== void 0 ? _order$sellSpecificat : [];
  return order === null || order === void 0 || (_order$travelers = order.travelers) === null || _order$travelers === void 0 ? void 0 : _order$travelers.map(traveler => {
    var _options$0$price, _options$, _markup$value, _price$value;
    const {
      options = []
    } = (baggageSpecification === null || baggageSpecification === void 0 ? void 0 : baggageSpecification.find(currTraveler => String(currTraveler === null || currTraveler === void 0 ? void 0 : currTraveler.travelerId) === String(traveler === null || traveler === void 0 ? void 0 : traveler.id))) || {};
    const {
      price,
      markup
    } = (_options$0$price = (_options$ = options[0]) === null || _options$ === void 0 ? void 0 : _options$.price) !== null && _options$0$price !== void 0 ? _options$0$price : {};
    return {
      ...traveler,
      id: (traveler === null || traveler === void 0 ? void 0 : traveler.id) || '',
      productPreSelection: order.productPreSelection || '',
      markup: (_markup$value = markup === null || markup === void 0 ? void 0 : markup.value) !== null && _markup$value !== void 0 ? _markup$value : null,
      price: (_price$value = price === null || price === void 0 ? void 0 : price.value) !== null && _price$value !== void 0 ? _price$value : 0
    };
  });
};
//# sourceMappingURL=baggageUtils.js.map